/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseKingDifferenceMediaCf013Fragment} from '@amblique/contentful/app/contentful/fragments/king-difference-media-cf013/base-king-difference-media-cf013.fragment';
import {BaseImageFragment} from '@amblique/contentful/app/contentful/fragments/image/base-image.fragment';

export const KingDifferenceMediaCf013Fragment = gql`
  ${BaseImageFragment}
  ${BaseKingDifferenceMediaCf013Fragment}

  fragment KingDifferenceMediaCf013Fragment on KingDifferenceMediaCf013 {
    ...BaseKingDifferenceMediaCf013Fragment

    mainImagesCollection {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
      }
    }
    mainImagesCursorCollection {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
      }
    }
    thumbnailImagesCollection {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
      }
    }
    thumbnailImagesCursorCollection {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
      }
    }
  }
`;
